import { SkipLinkSelector, SkipLinkType } from './types'

export const SKIP_LINKS_SELECTORS: Record<SkipLinkType, SkipLinkSelector> = {
  mainContent: { value: 'main', type: 'selector' },
}

export const SKIP_LINKS_TITLES: Record<SkipLinkType, string> = {
  mainContent: 'Skip To Main Content',
}

export const getTargets = (targets: [string, SkipLinkSelector][]): [string, HTMLElement][] =>
  targets.map(([targetType, target]) => {
    if (target.type === 'id') {
      return [targetType, document.getElementById(target.value)]
    }

    return [targetType, document.querySelector(target.value)]
  })
